export default "__VITE_ASSET__p68FSI$___"